import { useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { InputBox } from "../form-elements/inputbox.component";
import { DropdownMenu } from "../form-elements/dropdownmenu.component";
import { statusesAtAddress, usStates } from "./values";
import { InputBoxMoney } from "../form-elements/inputbox-money.component";
import { InputBoxNumber } from "../form-elements/inputbox-number.component";

interface CoapplicantResidentialAddressFormProps {
  values?: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue?: any;
}

export const initialValuesCoapplicantResidentialAddress = {
  // step #5
  coapplicantResidentialAddressLine1: "",
  coapplicantResidentialCity: "",
  coapplicantResidentialState: "",
  coapplicantResidentialZipCode: "",
  coapplicantYearsAtResidentialAddress: "",
  coapplicantMonthsAtResidentialAddress: "",
  coapplicantStatusAtResidentialAddress: "",
  coapplicantMonthlyPayment: "",

  coapplicantPreviousAddressLine1: "",
  coapplicantPreviousCity: "",
  coapplicantPreviousState: "",
  coapplicantPreviousZipCode: "",
  coapplicantPreviousYearsAtAddress: "",
  coapplicantPreviousMonthsAtAddress: "",
};

export const CoapplicantResidentialAddressForm: React.FC<CoapplicantResidentialAddressFormProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  useEffect(() => {
    if (values.haveCoApplicant === false) {
      setFieldValue(
        "coapplicantResidentialAddressLine1",
        initialValuesCoapplicantResidentialAddress.coapplicantResidentialAddressLine1
      );
      setFieldValue(
        "coapplicantResidentialCity",
        initialValuesCoapplicantResidentialAddress.coapplicantResidentialCity
      );
      setFieldValue(
        "coapplicantResidentialState",
        initialValuesCoapplicantResidentialAddress.coapplicantResidentialState
      );
      setFieldValue(
        "coapplicantResidentialZipCode",
        initialValuesCoapplicantResidentialAddress.coapplicantResidentialZipCode
      );
      setFieldValue(
        "coapplicantYearsAtResidentialAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantYearsAtResidentialAddress
      );
      setFieldValue(
        "coapplicantMonthsAtResidentialAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantMonthsAtResidentialAddress
      );
      setFieldValue(
        "coapplicantStatusAtResidentialAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantStatusAtResidentialAddress
      );
      setFieldValue("coapplicantMonthlyPayment", initialValuesCoapplicantResidentialAddress.coapplicantMonthlyPayment);

      setFieldValue(
        "coapplicantPreviousAddressLine1",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousAddressLine1
      );
      setFieldValue("coapplicantPreviousCity", initialValuesCoapplicantResidentialAddress.coapplicantPreviousCity);
      setFieldValue("coapplicantPreviousState", initialValuesCoapplicantResidentialAddress.coapplicantPreviousState);
      setFieldValue(
        "coapplicantPreviousZipCode",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousZipCode
      );
      setFieldValue(
        "coapplicantPreviousYearsAtAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousYearsAtAddress
      );
      setFieldValue(
        "coapplicantPreviousMonthsAtAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousMonthsAtAddress
      );
    }
  }, [setFieldValue, values.haveCoApplicant]);

  useEffect(() => {
    if (
      // less than 2 years at address
      (values.coapplicantYearsAtResidentialAddress || values.coapplicantMonthsAtResidentialAddress) &&
      Number(values.coapplicantYearsAtResidentialAddress) * 12 + Number(values.coapplicantMonthsAtResidentialAddress) <
        24
    ) {
      setFieldValue(
        "coapplicantPreviousAddressLine1",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousAddressLine1
      );
      setFieldValue("coapplicantPreviousCity", initialValuesCoapplicantResidentialAddress.coapplicantPreviousCity);
      setFieldValue("coapplicantPreviousState", initialValuesCoapplicantResidentialAddress.coapplicantPreviousState);
      setFieldValue(
        "coapplicantPreviousZipCode",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousZipCode
      );
      setFieldValue(
        "coapplicantPreviousYearsAtAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousYearsAtAddress
      );
      setFieldValue(
        "coapplicantPreviousMonthsAtAddress",
        initialValuesCoapplicantResidentialAddress.coapplicantPreviousMonthsAtAddress
      );
    }
  }, [setFieldValue, values.coapplicantYearsAtResidentialAddress, values.coapplicantMonthsAtResidentialAddress]);

  const handleChangeSameAsBuyer = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setFieldValue("coapplicantResidentialAddressLine1", values.applicantResidentialAddressLine1);
      setFieldValue("coapplicantResidentialCity", values.applicantResidentialCity);
      setFieldValue("coapplicantResidentialState", values.applicantResidentialState);
      setFieldValue("coapplicantResidentialZipCode", values.applicantResidentialZipCode);
    } else {
      setFieldValue("coapplicantResidentialAddressLine1", "");
      setFieldValue("coapplicantResidentialCity", "");
      setFieldValue("coapplicantResidentialState", "");
      setFieldValue("coapplicantResidentialZipCode", "");
    }
  };

  return (
    <>
      {values.haveCoApplicant === true ? (
        <div id="coapplicant-info">
          <Row>
            <Col xs={12}>
              <h3>Co-Buyer Residential Information</h3>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Check
                  inline
                  type="checkbox"
                  name="isSameAsBuyer"
                  value="true"
                  id="isSameAsBuyer"
                  label="Same as Buyer?"
                  onChange={handleChangeSameAsBuyer}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <InputBox
                label="Physical Address"
                name="coapplicantResidentialAddressLine1"
                value={values.coapplicantResidentialAddressLine1}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={
                  touched.coapplicantResidentialAddressLine1 &&
                  !errors.residcoapplicantResidentialAddressLine1entialAddressLine1
                }
                isInvalid={touched.coapplicantResidentialAddressLine1 && errors.coapplicantResidentialAddressLine1}
                errorFeedback={errors.coapplicantResidentialAddressLine1}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} md={4} lg={4}>
              <InputBox
                label="City"
                name="coapplicantResidentialCity"
                value={values.coapplicantResidentialCity}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantResidentialCity && !errors.coapplicantResidentialCity}
                isInvalid={touched.coapplicantResidentialCity && errors.coapplicantResidentialCity}
                errorFeedback={errors.coapplicantResidentialCity}
              />
            </Col>
            <Col xs={12} sm={6} md={4} lg={4}>
              <DropdownMenu
                label="State"
                name="coapplicantResidentialState"
                options={usStates}
                value={values.coapplicantResidentialState}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantResidentialState && !errors.coapplicantResidentialState}
                isInvalid={touched.coapplicantResidentialState && errors.coapplicantResidentialState}
                errorFeedback={errors.coapplicantResidentialState}
              />
            </Col>
            <Col xs={12} sm={6} md={4} lg={4}>
              <InputBoxNumber
                label="Zip"
                name="coapplicantResidentialZipCode"
                value={values.coapplicantResidentialZipCode}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.coapplicantResidentialZipCode && !errors.coapplicantResidentialZipCode}
                isInvalid={touched.coapplicantResidentialZipCode && errors.coapplicantResidentialZipCode}
                errorFeedback={errors.coapplicantResidentialZipCode}
              />
            </Col>
          </Row>

          <Row xs={12}>
            <Col>Time at Residence</Col>
          </Row>

          <Row>
            <Col xs={6} lg={3}>
              <InputBoxNumber
                label="Years"
                name="coapplicantYearsAtResidentialAddress"
                value={values.coapplicantYearsAtResidentialAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.coapplicantYearsAtResidentialAddress && !errors.coapplicantYearsAtResidentialAddress}
                isInvalid={touched.coapplicantYearsAtResidentialAddress && errors.coapplicantYearsAtResidentialAddress}
                errorFeedback={errors.coapplicantYearsAtResidentialAddress}
              />
            </Col>
            <Col xs={6} lg={3}>
              <InputBoxNumber
                label="Months"
                name="coapplicantMonthsAtResidentialAddress"
                value={values.coapplicantMonthsAtResidentialAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.coapplicantMonthsAtResidentialAddress && !errors.coapplicantMonthsAtResidentialAddress}
                isInvalid={
                  touched.coapplicantMonthsAtResidentialAddress && errors.coapplicantMonthsAtResidentialAddress
                }
                errorFeedback={errors.coapplicantMonthsAtResidentialAddress}
              />
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <DropdownMenu
                label="Status"
                name="coapplicantStatusAtResidentialAddress"
                options={statusesAtAddress}
                value={values.coapplicantStatusAtResidentialAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantStatusAtResidentialAddress && !errors.coapplicantStatusAtResidentialAddress}
                isInvalid={
                  touched.coapplicantStatusAtResidentialAddress && errors.coapplicantStatusAtResidentialAddress
                }
                errorFeedback={errors.coapplicantStatusAtResidentialAddress}
              />
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <InputBoxMoney
                label="Mortgage/Rent Amount"
                name="coapplicantMonthlyPayment"
                value={values.coapplicantMonthlyPayment}
                setFieldValue={setFieldValue}
                onBlur={handleBlur}
                isValid={touched.coapplicantMonthlyPayment && !errors.coapplicantMonthlyPayment}
                isInvalid={touched.coapplicantMonthlyPayment && errors.coapplicantMonthlyPayment}
                errorFeedback={errors.coapplicantMonthlyPayment}
              />
            </Col>
          </Row>

          {(touched.coapplicantYearsAtResidentialAddress || touched.coapplicantMonthsAtResidentialAddress) &&
          (values.coapplicantYearsAtResidentialAddress || values.coapplicantMonthsAtResidentialAddress) &&
          Number(values.coapplicantYearsAtResidentialAddress) * 12 +
            Number(values.coapplicantMonthsAtResidentialAddress) <
            24 ? (
            <>
              <Row>
                <Col xs={12}>
                  <label>* Previous address required if at current address less than two years:</label>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <InputBox
                    label="Previous Address"
                    name="coapplicantPreviousAddressLine1"
                    value={values.coapplicantPreviousAddressLine1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantPreviousAddressLine1 && !errors.coapplicantPreviousAddressLine1}
                    isInvalid={touched.coapplicantPreviousAddressLine1 && errors.coapplicantPreviousAddressLine1}
                    errorFeedback={errors.coapplicantPreviousAddressLine1}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={4}>
                  <InputBox
                    label="City"
                    name="coapplicantPreviousCity"
                    value={values.coapplicantPreviousCity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantPreviousCity && !errors.coapplicantPreviousCity}
                    isInvalid={touched.coapplicantPreviousCity && errors.coapplicantPreviousCity}
                    errorFeedback={errors.coapplicantPreviousCity}
                  />
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                  <DropdownMenu
                    label="State"
                    name="coapplicantPreviousState"
                    options={usStates}
                    value={values.coapplicantPreviousState}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.coapplicantPreviousState && !errors.coapplicantPreviousState}
                    isInvalid={touched.coapplicantPreviousState && errors.coapplicantPreviousState}
                    errorFeedback={errors.coapplicantPreviousState}
                  />
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                  <InputBoxNumber
                    label="Zip"
                    name="coapplicantPreviousZipCode"
                    value={values.coapplicantPreviousZipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantPreviousZipCode && !errors.coapplicantPreviousZipCode}
                    isInvalid={touched.coapplicantPreviousZipCode && errors.coapplicantPreviousZipCode}
                    errorFeedback={errors.coapplicantPreviousZipCode}
                  />
                </Col>
              </Row>

              <Row xs={12}>
                <Col>Time at Previous Address</Col>
              </Row>

              <Row>
                <Col xs={6} lg={3}>
                  <InputBoxNumber
                    label="Years"
                    name="coapplicantPreviousYearsAtAddress"
                    value={values.coapplicantPreviousYearsAtAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantPreviousYearsAtAddress && !errors.coapplicantPreviousYearsAtAddress}
                    isInvalid={touched.coapplicantPreviousYearsAtAddress && errors.coapplicantPreviousYearsAtAddress}
                    errorFeedback={errors.coapplicantPreviousYearsAtAddress}
                  />
                </Col>
                <Col xs={6} lg={3}>
                  <InputBoxNumber
                    label="Months"
                    name="coapplicantPreviousMonthsAtAddress"
                    value={values.coapplicantPreviousMonthsAtAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    isValid={touched.coapplicantPreviousMonthsAtAddress && !errors.coapplicantPreviousMonthsAtAddress}
                    isInvalid={touched.coapplicantPreviousMonthsAtAddress && errors.coapplicantPreviousMonthsAtAddress}
                    errorFeedback={errors.coapplicantPreviousMonthsAtAddress}
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
